import React, { Component } from 'react';
import Axios from 'axios';
import { ROOT_URL } from '../../../actions';
import { PriceFormatter1 } from '../../../helper';
import { Card, Alert, CardDeck, Row, Col, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function jsonToParam(param, startWith) {
    if (param) {
        let paramArr = [];
        Object.keys(param).forEach(function (key) {
            if (typeof param[key] != 'object')
                paramArr.push(encodeURIComponent(key) + '=' + encodeURIComponent(param[key]));
        });
        return startWith ? startWith + paramArr.join('&') : paramArr.join('&');
    } else {
        return '';
    }
}

function renderTooltip(text, props) {
    return (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );
}

class MembershipQualificationWireframe extends Component {

    constructor(props) {
        super(props);
        this.state = {
            qualification:[],
            params: {
                verifiedSource: false,
                buyingGroupId: 1,
            }
        }
    }

    static getDerivedStateFromProps(props, state) {
        let currentStateParams = state.params;
        // console.log('Existing state', props.params);
        currentStateParams = props.params;
        currentStateParams.verifiedSource = props.verifiedSource;
        return {
            params: currentStateParams
        };
    }

    // componentWillMount() {
    //     return this.props.buyingGroupId === 1;
    // }

    componentDidMount() {
        
        Axios.get(`${ROOT_URL}/membership-qualification-status` + jsonToParam(this.state.params, '?'))
            .then(resp => this.setState({ qualification: resp.data }));
        Axios.get(`${ROOT_URL}/member-purchases` + jsonToParam(this.state.params, '?'))
            .then(resp => this.setState({ rebate: resp.data }));


    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    showAllTier = () => {
        
        return (
            this.setState({ showModal: true })
        );

    }


    render() {
        let qualificationvalue = this.state.qualification || [];
        let qualifiedindex = qualificationvalue.findIndex(v => v.activeMembership == true);
        qualifiedindex =  qualifiedindex > 5 ? 5 : (qualifiedindex == -1 ? 0: qualifiedindex);
        qualificationvalue = qualificationvalue.filter((d,index) => index >= qualifiedindex 
        && index <= qualifiedindex+2 )

        qualificationvalue = qualificationvalue ? qualificationvalue:[]
        
        const { show } = this.props;
        if (this.state.params.buyingGroupId === "2") {
            return (
                ""
                // <Alert variant="primary" className="shadow-sm">Qualification Not Available</Alert>
            )
        }
        else {
            return (
                
               console.log('qualificationnnn', this.state.params.year),
                // this.state.qualification ?
                
                    <Card className="shadow-sm">
                        <Card.Body>
                            <Card.Title> <Row> 
                                <h4 style={{ marginLeft: "10px" }}> Membership Qualification</h4>
                               - Tier {qualificationvalue.map((level, index)  =>
                                <h4 style = {{marginTop:"0.5px", marginLeft: "2px"}}> {level.activeMembership === true  ?  level.previousYearTier :<span></span>}
                                     </h4> )}
                                <h5 style={{ marginRight: "5px", marginTop: "5px",marginLeft:"800px"}} >All Tiers{" "}</h5>
                                <OverlayTrigger overlay={(<Tooltip id="callModal">Overall Member Qualification Tiers</Tooltip>)}
                                    popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                                    <Link onClick={(e) => {
                                        this.showAllTier()
                                    }}> {" "} <i className="fa fa-eye fa-2x" ></i></Link>
                                </OverlayTrigger>
                               
                                    </Row></Card.Title>

                            <Row>

                                {qualificationvalue.map((level, index) => {
                                   
                                
                                        return <Col>
                                            <h4 className="d-flex my-2">
                                            <span>Tier{level.tier}</span>
                                                <span className="ml-auto">
                                                    {level.qualified ? <React.Fragment>
                                                        <span>Qualified</span> <i class="fas fa-check text-success"></i>
                                                    </React.Fragment> : <React.Fragment>
                                                            <i class="fas fa-times text-danger"></i>
                                                        </React.Fragment>}
                                                </span>
                                            </h4>
                                            {/* {level.activeMembership == true ? */}
                                            <div className="border p-2">
                                         
                                                <Row >
                                              
                                                {this.renderCriteria(level, index)}
                                            </Row>
                                             
                                            </div> 
                                         
                                               
                                        </Col>
                                        
                                      
                                   
                                })}
                            </Row>
                        </Card.Body>
                        {this.state.showModal ?
                            <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                                <div className="modal-dialog" role="document" style={{ minWidth: "500px" }} >

                                    <div className="modal-content" style={{ width: "500px" }}>

                                        <div className="modal-header">
                                            <h5 className="modal-title" >Membership Qualification</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeModal() }} >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body" >


                                            <Row>

                                                {this.state.qualification.map((level, index) =>
                                                    <Col>
                                                        <h5 className="d-flex my-2">
                                                            <span>Tier {(index + 1)}</span>
                                                            <span className="ml-auto">
                                                                {level.qualified ? <React.Fragment>
                                                                    <span>Qualified</span> <i class="fas fa-check text-success"></i>
                                                                </React.Fragment> : <React.Fragment>
                                                                        <i class="fas fa-times text-danger"></i>
                                                                    </React.Fragment>}
                                                            </span>
                                                        </h5>
                                                        <div className="border p-2">
                                                            <Row >
                                                                {this.renderCriteriaPopup(level, index)}
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                )}
                                            </Row>

                                        </div>


                                    </div>
                                </div>
                            </div>
                            : ''
                        }
                    </Card> 

                // : <Alert variant="primary" className="shadow-sm">Qualification Not Available</Alert>
            )
        }
    }

    renderCriteria(level, index) {
        
        let width = 0;
        let gap = 0;
        let rebateGap = 0;
        let variant = 'success';

       // rebate = level.memberPurchasesRebate.rebateGap

        width = level.currentPurchases / level.min * 100;


        width = width >= 100 ? 100 : width;

        if (width < 50) {
            variant = 'danger';
        } else if (width >= 50 && width < 100) {
            variant = 'warning';
        }
       
        if (level.qualified == true )  {
            gap = '$0';
        }
        else {
            gap = PriceFormatter1(level.min-level.currentPurchases);
        }
        if(level.memberPurchasesRebate == null)
        {
             rebateGap = ''
        }
        else
        {
             rebateGap = level.memberPurchasesRebate.rebateGap;
        }

        return (
            <Col>
                <OverlayTrigger placement="bottom" overlay={props => renderTooltip(<strong>{
                    <React.Fragment>
                        <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                            <div><strong>Target : </strong>
                                {'Purchase of ' + PriceFormatter1(level.min) + ' from all vendors'} </div>
                            <br />
                            <div> <strong>Actual: </strong>
                                {'Purchased ' + PriceFormatter1(level.currentPurchases) + ' from all vendors'}</div>
                            <br />
                            <div><strong>Gap: </strong>
                                {gap}</div>
                            <br />
                            <div><strong>Estimated Rebate Gain: </strong>
                                {PriceFormatter1(rebateGap)}</div>
                        </div>
                    </React.Fragment>
                }</strong>, props)}>
                    <ProgressBar now={width} variant={variant} />
                </OverlayTrigger>
            </Col>
        );
        
    }

    renderCriteriaPopup(level, index) {

        let width = 0;
        let gap = 0;
        let variant = 'success';


        width = level.currentPurchases / level.min * 100;


        width = width >= 100 ? 100 : width;

        if (width < 50) {
            variant = 'danger';
        } else if (width >= 50 && width < 100) {
            variant = 'warning';
        }

        if (level.qualified == true) {
            gap = '$0';
        }
        else {
            gap = PriceFormatter1(level.min-level.currentPurchases);
        }
        return (
            <Col style={{ width: "500px" }}>
                <OverlayTrigger placement="top" overlay={props => renderTooltip(<strong>{
                    <React.Fragment>
                        <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                            <div><strong>Target : </strong>
                                {'Purchase of' + PriceFormatter1(level.min) + ' from all vendors'} </div>
                            <br />
                            <div> <strong>Actual: </strong>
                                {'Purchased' + PriceFormatter1(level.currentPurchases) + ' from all vendors'}</div>
                            <br />
                            <div><strong>Gap: </strong>
                                {gap}</div>

                        </div>
                    </React.Fragment>
                }</strong>, props)}>
                    <ProgressBar now={width} variant={variant} />
                </OverlayTrigger>
            </Col>
        );
    }
}

export default MembershipQualificationWireframe;
